export default {
  name: 'NotificationText'
};